module.exports = __webpack_public_path__ + "img/编组4.045d17d5.png";